export default __webpack_public_path__ + "static/media/art-blk-1.f70ef203.png";